export const offerQuestion = () => {

	const links = document.querySelectorAll(".offer-question-link");
	const offerForm = document.querySelector(".offer-form");

	if (links && offerForm)
	{
		const firstInput = offerForm.querySelector(".wpcf7-text");

		links.forEach((link) =>
		{
			link.addEventListener("click", (event) =>
			{
				event.preventDefault();

				offerForm.scrollIntoView({
					behavior: 'smooth',
					block: 'center', // Defines vertical alignment. default: start
				});

				window.setTimeout(() => {
					offerForm.classList.add("offer-form--highlighted");
					firstInput.focus();

					window.setTimeout(() => {
						offerForm.classList.remove("offer-form--highlighted");

					}, 2200);
				}, 200);
			});

		});
	}
};
